var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSettings(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    role: "img",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    "aria-hidden": "true",
    className: "gnav-header-1i89ga9 eac13zx0",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M9.85 2.448A.5.5 0 0110.345 2h3.31a.5.5 0 01.498.448l.253 2.407c1.09.33 2.076.88 2.903 1.594l2.336-1.002a.528.528 0 01.654.209l1.634 2.688a.473.473 0 01-.137.643l-2.08 1.42a7.167 7.167 0 010 3.186l2.08 1.42a.473.473 0 01.137.643L20.3 18.344a.528.528 0 01-.654.209L17.31 17.55a7.994 7.994 0 01-2.903 1.594l-.253 2.407a.5.5 0 01-.497.448h-3.31a.5.5 0 01-.498-.448l-.253-2.407a7.996 7.996 0 01-2.904-1.594l-2.335 1.002a.528.528 0 01-.655-.209l-1.634-2.688a.473.473 0 01.138-.643l2.08-1.42a7.167 7.167 0 010-3.186l-2.08-1.42a.473.473 0 01-.138-.643l1.634-2.688a.528.528 0 01.655-.209L6.692 6.45a7.994 7.994 0 012.904-1.594l.253-2.407zM12 16.363c2.537 0 4.593-1.953 4.593-4.363S14.537 7.637 12 7.637C9.465 7.637 7.408 9.59 7.408 12s2.057 4.363 4.593 4.363z",
    clipRule: "evenodd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/Settings.652134da2bae107f0fd84ce5a64aa264.svg";
export { ForwardRef as ReactComponent };